import { useRef, useState } from 'react';

/**
 * Determines if <PullToReload />
 */
export const useEnablePullToReloadOnScroll = () => {
  const [pullToReloadEnabled, setPullToReloadEnabled] = useState(true);
  const scrollRef = useRef<HTMLElement | null>(null);

  const setScrollRef = (e: HTMLElement | null) => {
    scrollRef.current = e;
  };

  const getScrollPositionForReload = () => {
    const scrollTop = scrollRef?.current?.scrollTop;

    if (scrollTop && pullToReloadEnabled) {
      setPullToReloadEnabled(false);
    } else if (!scrollTop && !pullToReloadEnabled) {
      setPullToReloadEnabled(true);
    }
  };

  return { setScrollRef, pullToReloadEnabled, getScrollPositionForReload };
};
